import Axios from 'axios';
import { useAuth } from '../../hooks/useAuth';
import { FLAVOR_PRODUCTION } from '../../../config/constants';
import { Flavor } from '../../../config/types';
import { getConfig } from '../../../config/getConfig';

export function useDownloadBGFile(controlId: string) {
  const { accessToken, logout } = useAuth();

  const downloadFile = async () => {
    const axios = Axios.create();
    const config = await localStorage.getItem('APP_CONFIG');
    const { API_URL } = getConfig((config ?? FLAVOR_PRODUCTION) as Flavor);

    axios.interceptors.request.use(
      async (config) => {
        config.headers.Authorization = accessToken ? `Bearer ${accessToken}` : undefined;

        return config;
      },
      (err) => Promise.reject(err)
    );

    axios.interceptors.response.use(
      (response) => response,
      (err) => {
        if (err.response.status === 401) {
          logout();
        }

        return Promise.reject(err);
      }
    );

    const res = await axios.get(`${API_URL}/api/v1/background-controls/controle-file/download`, {
      params: { controlId },
      responseType: 'blob',
    });

    return res.data as Blob;
  };

  return downloadFile;
}
